
// import {languages, currencies} from "./data";

const state = {
	// languages,
	selectedLocale: localStorage.language ? localStorage.language : 'en',
	// currencies,
	// selectedCurrency: currencies[0],
	rtlLayout: false,

	selectCurrency: {
		selectedCurrency: (localStorage.selectedCurrency) ? localStorage.selectedCurrency : 'AED',
      CurrencyMultiplier: (localStorage.CurrencyMultiplier) ? parseFloat(localStorage.CurrencyMultiplier) : parseFloat(1),
	},

}

// getters
const getters = {
	// languages: state => {
	// 	return state.languages;
	// },
	selectedLocale: state => {
		return state.selectedLocale;
	},
	currencies: state => {
		return state.currencies;
	},
	selectCurrency: state => {
		return state.selectCurrency;
	},
	rtlLayout: state => {
		return state.rtlLayout;
	}
}

// actions
const actions = {
	changeLanguage(context, payload) {
		context.commit('changeLanguageHandler', payload);
	},
	changeCurrency(context, payload) {
		context.commit('changeCurrency', payload);
	},
	changeRtlLayout(context) {
		context.commit('rtlLayoutHandler');
	}
}

// mutations
const mutations = {
	/**
    * method for setting language state
   */
	changeLanguageHandler(state, language) {
		state.selectedLocale = language;
		if (language.Language_Code == "ar" && !state.rtlLayout) {
			state.rtlLayout = true;
		} else {
			state.rtlLayout = false;
		}
	},
	/**
    * method for setting currency
   */
	changeCurrency(state, currencies) {
		state.selectCurrency = currencies;
	},
	/**
    * method for setting rtl layout
   */
	rtlLayoutHandler(state) {
		state.rtlLayout = !state.rtlLayout;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
